<template>
  <div v-if="hudDisplaying" id="HUDPanel" class="flex flex-column">
    <button v-for="item in suggestions" :key="item.url" @click="openURL(item.url)" class="noselect" id="HUDContent">
      <p>{{ item.title }}<br /><span style="opacity: .5; font-style: italic;"><i class="las la-external-link-alt"></i> {{ item.source }}</span></p>
    </button>
  </div>
</template>

<script>
import Suggestions from '@/assets/data/suggestions.json'
export default {
  data() {
    return {
      hudDisplaying: true,
      suggestions: Suggestions
    }
  },
  methods: {
    openURL(url) {
      window.open(url, '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>  
  button {
    position: relative;
    padding: clamp(.5rem, .5vw, 1.5rem) clamp(1rem, 1vw, 3rem) !important;

    // background: rgba($color: #1d1d1d, $alpha: .7);
    color: white;

    border: 1px solid transparent;
    border-radius: clamp(1rem, 1vw, 3rem);

    align-items: center;
    background-color: initial;
    background-image: linear-gradient(#272727, #1a1a1a);

    box-sizing: border-box;
    color: #fff;
    cursor: pointer;

    text-decoration: none;
    transition: all 150ms;
    vertical-align: baseline;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;


  * {
    margin: 0;
  }
  }
  #HUDContent {
    font-size: c;
    text-align: left;
    padding: 5px;
    margin-bottom: 5px;

    max-width: 60%;

    border-radius: 5px;
    border: 1px solid black;
    
    background-color: white;

    p {
      margin: 0;
    }
  }
</style>